<template>
  <basic-card>
    <data-table
        :data="operationDefinitions"
        :configuration="operationDefinitionsTableConfig"
        @add="handleAdd"
        @delete="handleDelete"
        @duplicate="handleDuplicate"
        @focusedChanged="focusedChanged"
        component-id="operation-definitions-list"
    />
  </basic-card>
</template>

<script>
import BasicCard from "../components/layout/BasicCard";
import DataTable from "../components/table/DataTable";

export default {
  name: "OperationDefinitionsListCard",
  components: {DataTable, BasicCard},
  props: {
    operationDefinitions: Array
  },
  data: function () {
    return {
      operationDefinitionsTableConfig: {
        enableAdd: true,
        allowEdit: true,
        selectionMode: 'single',
        columns: [
          {
            caption: "Id",
            datum: d => d.id.substr(0, 5)
          },
          {
            caption: this.$t('name'),
            datum: d => d.name
          },
          {
            caption: this.$t('code'),
            datum: d => d.code
          }
        ],
        actions: [
          {
            name: "delete",
            icon: "trash",
            tooltip: this.$t('operationDefinition.delete')
          },
          {
            name: "duplicate",
            icon: "clone",
            tooltip: this.$t('operationDefinition.clone')
          }
        ]
      }
    }
  },
  methods: {
    handleDelete(definition) {
      this.$emit('delete', definition)
    },
    handleAdd() {
      this.$emit('add', {id: null, model: {dynaProperties: {}}});
    },
    handleDuplicate(focused) {
      this.$emit('duplicate', { ... focused, id: undefined} );
    },
    focusedChanged(focused) {
      this.$emit('focusedChanged', focused);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
